import FormattedMessage from 'I18n/components/FormattedMessage';
import { useSelector } from 'react-redux';
import { RECURRING } from 'self-service-api/constants/ChargeTypes';
import { ADD_ON_CARD } from '../../constants/tracking/Locations';
import { useAppSelector } from '../../reducers';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { calculatedPriceSelector } from '../../selectors/PricingSelectors';
import { productForSkuIdSelector } from '../../selectors/ProductsSelectors';
import PriceDisplay from '../common/pricing/PriceDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const AddOnCardPricing = ({
  productConfigurations,
  skuId,
  term
}) => {
  const currencyCode = useSelector(activeCurrencySelector);
  const product = useAppSelector(state => productForSkuIdSelector(state, {
    skuId
  }));
  const isRecurring = product && product.chargeType === RECURRING;
  const singleUnitPrice = useAppSelector(state => {
    const pricingInfo = calculatedPriceSelector(state, {
      productConfigurations,
      queryParamTerm: term
    });
    return isRecurring ? pricingInfo.monthly.calculatedPrice : pricingInfo.oneTimeFee.calculatedPrice;
  });
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": `${ADD_ON_CARD}-${product.apiName}-price`,
    children: [/*#__PURE__*/_jsx(PriceDisplay, {
      price: singleUnitPrice,
      currencyCode: currencyCode
    }), isRecurring ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "planBuilder.priceDisplay.perMonth"
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      className: "m-left-1",
      message: "pricingPage.notes.oneTimeFeeParentheses"
    })]
  });
};